import { ReservationState } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';

export const reservationStatusOptions = {
    [ReservationState.Future]: TextKey.ReservationTimeStateFuture,
    [ReservationState.ToBeCheckedIn]: TextKey.ReservationTimeStateToBeCheckedIn,
    [ReservationState.CheckedInOnline]: TextKey.OnlineCheckedIn,
    [ReservationState.CheckInMissed]: TextKey.ReservationTimeStateCheckInMissed,
    [ReservationState.Cancelled]: TextKey.ServiceOrderStateCanceled,
    [ReservationState.Undefined]: TextKey.LedgersReservationStatusNull,
};
